import { render, staticRenderFns } from "./ExcMobNavItem.vue?vue&type=template&id=2e33ab76&scoped=true&"
import script from "./ExcMobNavItem.vue?vue&type=script&lang=js&"
export * from "./ExcMobNavItem.vue?vue&type=script&lang=js&"
import style0 from "./ExcMobNavItem.vue?vue&type=style&index=0&id=2e33ab76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e33ab76",
  null
  
)

export default component.exports